import { MakeLogicType, actions, kea, key, path, props, reducers } from 'kea'

import { BreakdownFilter, TileFilters } from '~/queries/schema/schema-general'
import { AnyPropertyFilter } from '~/types'

export interface TileLogicProps {
    dashboardId: number
    tileId: number
    filtersOverrides?: TileFilters
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface tileLogicValues {
    overrides: TileFilters
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface tileLogicActions {
    resetOverrides: () => {
        value: true
    }
    setBreakdown: (breakdown_filter: BreakdownFilter | null | undefined) => {
        breakdown_filter: BreakdownFilter | null | undefined
    }
    setDates: (
        date_from: string | null | undefined,
        date_to: string | null | undefined,
        explicitDate?: boolean
    ) => {
        date_from: string | null | undefined
        date_to: string | null | undefined
        explicitDate: boolean | undefined
    }
    setProperties: (properties: AnyPropertyFilter[] | null | undefined) => {
        properties: AnyPropertyFilter[] | null | undefined
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface tileLogicMeta {
    key: string
}

export type tileLogicType = MakeLogicType<tileLogicValues, tileLogicActions, TileLogicProps, tileLogicMeta>

export const tileLogic = kea<tileLogicType>([
    path(['scenes', 'dashboard', 'tileLogic']),
    props({} as TileLogicProps),
    key((p: TileLogicProps) => `${p.dashboardId}:${p.tileId}`),

    actions(() => ({
        setDates: (
            date_from: string | null | undefined,
            date_to: string | null | undefined,
            explicitDate?: boolean
        ) => ({
            date_from,
            date_to,
            explicitDate,
        }),
        setProperties: (properties: AnyPropertyFilter[] | null | undefined) => ({ properties }),
        setBreakdown: (breakdown_filter: BreakdownFilter | null | undefined) => ({ breakdown_filter }),
        resetOverrides: true,
    })),

    reducers(({ props }) => ({
        overrides: [
            (props.filtersOverrides ?? {}) as TileFilters,
            {
                setDates: (state, { date_from, date_to, explicitDate }) => {
                    const newState = { ...state }
                    if (date_from !== undefined && date_from !== null) {
                        newState.date_from = date_from
                    } else {
                        delete newState.date_from
                    }
                    if (date_to !== undefined && date_to !== null) {
                        newState.date_to = date_to
                    } else {
                        delete newState.date_to
                    }
                    if (explicitDate !== undefined) {
                        newState.explicitDate = explicitDate
                    } else {
                        delete newState.explicitDate
                    }
                    return newState
                },
                setProperties: (state, { properties }) => {
                    const newState = { ...state }
                    if (properties && properties.length > 0) {
                        newState.properties = properties
                    } else {
                        delete newState.properties
                    }
                    return newState
                },
                setBreakdown: (state, { breakdown_filter }) => ({ ...state, breakdown_filter }),
                resetOverrides: () => ({}),
            },
        ],
    })),
])
